/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Row } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { AdminTransfer } from 'src/core/models'
import { showNotification } from 'src/core/helpers'
import { transfersColumns } from 'src/core/table-columns'
import TransferListHeader from './TransferListHeader/TransferListHeader'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { CustomSeo, CustomCol, GoBackLink, PageTitle, CustomCard, CustomTable } from 'src/components'
import { adminTransfersSelector, resetRejectTransferState, resetValidateTransferState, validateAdminTransferSelector } from 'src/features'
import { rejectAdminTransferSelector } from 'src/features/admin/selectors'

const ValidateTransferPageContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { width } = useWindowSize()
  const { filtered, loading } = useAppSelector(adminTransfersSelector)
  const { success: successValidation, error: errorValidation } = useAppSelector(validateAdminTransferSelector)
  const { success: successReject, error: errorReject } = useAppSelector(rejectAdminTransferSelector)
  const isMobile = width <= 800


  useEffect(() => {
    if (successValidation) {
      showNotification('success', t('Transfer.Validated'))
      dispatch(resetValidateTransferState())
    }
    if (errorValidation) {
      showNotification('error', t('Validate.Error'))
      dispatch(resetValidateTransferState())
    }
    if (successReject) {
      showNotification('success', t('Transfer.RejectedTransferSuccess'))
      dispatch(resetRejectTransferState())
    }
    if (errorReject) {
      showNotification('error', t('Transfer.RejectedTransferError'))
      dispatch(resetRejectTransferState())
    }

  }, [successValidation, errorValidation, successReject, errorReject])

  return <>
    {/* Seo */}
    <CustomSeo title={t('My ClimateTrade: Validate Transfers')} />

    {/* Page Header */}
    <Row>
      <CustomCol>
        <GoBackLink link={'/admin'} label={t('Validate.GoBack')} />
      </CustomCol>
      <CustomCol>
        <div className={isMobile ? 'centered-div' : 'float-right'}>
          <PageTitle>{t('Transfer.Title')}</PageTitle>
        </div>
      </CustomCol>
    </Row>

    {/* Transfers List */}
    <CustomCard loading={loading}>
      <TransferListHeader quantity={filtered.length} />
      <Divider />
      <CustomTable
        columns={transfersColumns}
        dataSource={filtered}
        rowKey={(transfer: AdminTransfer) => transfer.order.id}
        rowClassName={() => 'fade-animation'}
        pageSize={10}
      />
    </CustomCard>
  </>
}

export default ValidateTransferPageContent


